import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'

const HeaderButtons = ({
  showSearchContextOptions,
  openSearch,
  openAdminDrawer,
  openDrawer,
  isAdmin,
  userId,
  userMail,
  adminConfig
}) => {
  const navigate = useNavigate()
  return (
    <div className="header-buttons">
      <div>
        {' '}
        <one-ux-button
          class="TableSearchButton"
          label="Dashboard"
          purpose="defualt"
          weight="normal"
          state="default"
          onClick={() => {
            navigate('/dashboardpage', { state: { userId, userMail } })
          }}>
          <one-ux-icon slot="start" icon="menu-user-insights" set="platform-center"></one-ux-icon>
        </one-ux-button>{' '}
      </div>
      <div
        style={{
          pointerEvents: showSearchContextOptions ? 'auto' : 'none',
          opacity: !showSearchContextOptions ? 0.2 : 1
        }}>
        {adminConfig.allowedSearchContext.includes('sql') && (
          <one-ux-button
            class="TableSearchButton"
            label="Table Search"
            purpose="defualt"
            weight="normal"
            state="default"
            onClick={openSearch}>
            <one-ux-icon icon="archive" slot="start" set="default"></one-ux-icon>
          </one-ux-button>
        )}
      </div>

      {isAdmin && (
        <div>
          <one-ux-button
            class="AdminButton"
            label="Admin"
            purpose="defualt"
            weight="normal"
            state="default"
            onClick={openAdminDrawer}>
            <one-ux-icon icon="user-admin" slot="start" set="user-permission"></one-ux-icon>
          </one-ux-button>
        </div>
      )}
      <one-ux-button
        class="SettingsButton"
        label="Settings"
        purpose="defualt"
        weight="normal"
        state="default"
        onClick={openDrawer}>
        <one-ux-icon icon="settings" slot="start" set="default"></one-ux-icon>
      </one-ux-button>
      <Link to="/">
        <one-ux-button class="homepage-button" label="Go to Homepage" purpose="defualt" weight="normal" state="default">
          {' '}
        </one-ux-button>
      </Link>
    </div>
  )
}
export default HeaderButtons
